import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#affix" }),
    /*#__PURE__*/_createTextVNode(" Affix ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Fix the element to a specific visible area. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUITargetContainer = _resolveComponent("EUITargetContainer")
  const _component_EUIFixedPosition = _resolveComponent("EUIFixedPosition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUITargetContainer),
    _createVNode(_component_EUIFixedPosition)
  ], 64))
}